export type AppConnectionPhase='idle'|'reconnecting'|'restored'|'failed';
let phase:AppConnectionPhase='idle';
let watchdog:number|undefined,notice:number|undefined;
const listeners=new Set<()=>void>();
const publish=(next:AppConnectionPhase)=>{phase=next;listeners.forEach(listener=>listener());};
const clear=()=>{window.clearTimeout(watchdog);window.clearTimeout(notice);watchdog=notice=undefined;};
export const isBundledClient=()=>/PKNiN\//i.test(navigator.userAgent);
export const appConnectionStatus={
 get:()=>phase,
 subscribe:(listener:()=>void)=>{listeners.add(listener);return()=>{listeners.delete(listener);};},
 watch:(expire:()=>void)=>{
  if(watchdog!==undefined||phase==='failed')return;
  watchdog=window.setTimeout(()=>{clear();publish('failed');expire();},40000);
 },
 retry:()=>{if(phase==='failed')return;window.clearTimeout(notice);notice=undefined;publish('reconnecting');},
 ready:()=>{
  if(phase==='failed')return;
  if(phase==='restored'){window.clearTimeout(watchdog);watchdog=undefined;return;}
  const recovered=phase==='reconnecting';clear();
  if(recovered){publish('restored');notice=window.setTimeout(()=>{notice=undefined;publish('idle');},2500);}
 },
 fail:()=>{clear();publish('failed');},
 reset:()=>{clear();publish('idle');},
};
